module.exports = __webpack_public_path__ + "img/btn-jc-bg.d2625d30.png";